<template>
  <div class="d-flex flex-column align-items-center page-wrapper">
    <img :src="require(`../../brand/${this.brandConfig.brand}/assets/evina-img.webp`)" class="w-100">
   
    <div class="header-text mt-3">
      {{ this.brandConfig.headerText }}
    </div>
    <div class="sub-header-text mt-4">
      {{ this.brandConfig.subHeaderText }}
    </div>
    <div v-if="brandConfig.brand ==='blg-en' || brandConfig.brand ==='blg-am'" class="sub-header-text mt-2">
      {{ this.brandConfig.unsubHelpText }}
    </div>
    <div @click="onTsAndCsClicked" class="terms-and-conditions mt-4">
      {{ this.brandConfig.termsAndConditionsText }}
    </div>
    <button class="accept-btn" @click="handleSubscription">{{ this.brandConfig.subscribeButton }}</button>
    <!--    <button class="decline-btn" @click="handleDecline">Decline</button>-->
  </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";
import {ref} from 'vue';
import OnevasService from "@/services/onevasService";
import CampaignService from "@/services/campaignService";
import {triggerGTMEvent} from "@/functions/addGTM";
import {ethiotelConfig} from "@/config";
import {v4 as guid} from "uuid";
import parseTransactionId from "@/functions/parseTransactionId";

const isLoading = ref(false);
const errorMessage = ref(null);

export default {
  data() {
    return {
      msisdn: undefined,
      correlationId: undefined,
      trxId: undefined,
      mcc: undefined,
      mnc: undefined,
      spId: undefined,
      serviceId: undefined,
      productId: undefined,
      authorization: undefined,
      redirectUrl: ethiotelConfig.redirectUrl,
      entryChannel: 'Web',
      campaignId: undefined,
    }
  },
  computed: {
    ...mapState(['brandConfig', 'msisdn'])
  },
  methods: {
    ...mapMutations(['setMsisdn']),
    onTsAndCsClicked() {
      window.open(this.brandConfig.termsAndConditionsUrl, '_blank');
    },
    generateCorrelationId() {
      return guid().toString();
    },
    generateBasicAuth() {
      // Create the username:password string
      const credentials = `${ethiotelConfig.username}:${ethiotelConfig.password}`;
      // Convert to Base64
      const base64Credentials = btoa(credentials);
      // Return with "Basic " prefix
      return `Basic ${base64Credentials}`;
    },
    handleSearchUrlParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const parsedTransactionId = parseTransactionId(urlParams.get('transaction_id'));
      // Extract all parameters
      this.msisdn = urlParams.get("msisdn") ?? null;
      this.correlationId = this.generateCorrelationId()
      this.trxId = this.correlationId;
      this.mcc = this.brandConfig?.mcc;
      this.mnc = this.brandConfig?.mnc;
      this.spId = this.brandConfig?.spId;
      this.serviceId = this.brandConfig?.serviceId;
      this.productId = this.brandConfig?.productId;
      this.authorization = this.generateBasicAuth();
      this.campaignId = urlParams.get("campaignId") ?? parsedTransactionId?.campaignId ?? this.brandConfig?.campaignId;
    },
    handleSubscriptionRedirect() {
      const redirectUrl = `${ethiotelConfig.redirectUrl}?correlatorId=${this.correlationId}&trxId=${this.trxId}&mcc=${this.mcc}&mnc=${this.mnc}&spId=${this.spId}&serviceId=${this.serviceId}&productId=${this.productId}&authorization=${this.authorization}&entryChannel=${this.entryChannel}&redirectURL=${this.brandConfig.redirectUrl}`;
      window.location.href = redirectUrl;
    },


async handleSubscription() {
      triggerGTMEvent('subscribe_button_clicked');
      isLoading.value = true;
      errorMessage.value = null;

      try {
        triggerGTMEvent('user_onnet');
        const urlParams = new URLSearchParams(window.location.search);
        const parsedTransactionId = parseTransactionId(urlParams.get('transaction_id'));
        const msisdn = urlParams.get('msisdn') ?? urlParams.get('phone');

        const {
          clickIdParameterName,
          publisherIdParameterName,
        } = await CampaignService.getCampaignConfig(this.campaignId);


        const publisherId = urlParams.get(`${publisherIdParameterName}`) ?? urlParams.get('publisherId') ?? parsedTransactionId?.publisherId;
        const clickId = parsedTransactionId?.clickId ?? urlParams.get(`${clickIdParameterName}`) ?? urlParams.get('clickid') ?? urlParams.get('clickId') ?? urlParams.get('click_id') ?? urlParams.get('ofreqid') ?? urlParams.get('transaction_id') ?? urlParams.get('pr_mbp_clickID');


        await OnevasService.queueUserSubscription(this.correlationId, msisdn, this.serviceId, this.productId, this.campaignId, clickId, publisherId, undefined, undefined);

        console.log('User subscription queued successfully');

        if (msisdn) {
          const user = await OnevasService.getUsers(msisdn, this.brandConfig.productId);

          if (user?.Status === "Active") {
            const gameUrl = `${this.brandConfig.gameUrl}?msisdn=${msisdn}`;
            window.location.href = gameUrl;
            return;
          }
        }

        this.handleSubscriptionRedirect();
      } catch (error) {
        console.error('=== Subscription Error ===');
        console.error('Error:', error);
        console.error('Error response:', error.response);
        errorMessage.value = error.response?.data?.message || error.message || "An unknown error occurred.";
      } finally {
        isLoading.value = false;
      }
    },
    handleDecline() {
      window.history.back();
    }
  },
  async mounted() {
    triggerGTMEvent('landing_page_view');
    console.log('=== Landing Page Mounted ===');
    this.handleSearchUrlParams();
  }
}
</script>

<style scoped>
.page-wrapper {
  height: 100vh;
}

.header-text {
  color: #FFFFFF;
  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
}

.sub-header-text {
  color: #FFFFFF;
  text-align: center;
  font-size: 0.8rem;
}

.terms-and-conditions {
  color: #FFFFFF;
  text-align: center;
  font-size: 0.7rem;
  text-decoration: underline;
}

.accept-btn {
  background-color: limegreen;
  color: #FFFFFF;
}

.decline-btn {
  background-color: #424242;
  color: #FFFFFF;
}

h1 {
  margin-bottom: 0.5rem;
  color: #333;
}

p {
  color: #666;
  line-height: 1.6;
}

button {
  padding: 15px 30px;
  font-size: 1.4rem;
  cursor: pointer;
  margin-top: 1.5rem;
  transition: background-color 0.3s, transform 0.2s;
  width: 80%;
  border: none;
}

button:hover:not(:disabled) {
  transform: translateY(-2px);
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.error-message {
  margin-top: 1.5rem;
  padding: 1rem;
  background-color: #ffebee;
  color: #c62828;
  border: 1px solid #ef9a9a;
  border-radius: 8px;
  text-align: left;
}

.error-message p {
  margin: 0;
  color: #c62828;
}

.footer {
  margin-top: 2rem;
  font-size: 0.8rem;
  color: #999;
}

.image-container {
  position: relative;
  display: inline-block;
  width: 100%;
}
.overlay-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #FFFFFF;
  margin: 0;
  z-index: 10;
}
</style>
